<ng-container *ngIf="isVisible()">
  <div [id]="navLink.id">
    <div class="ds-grid container-fluid pt-7">
      <div class="row">
        <h2 class="col text-center ds-heading--l mb-0">
          {{'productDetails.plansAndPricing' | cxTranslate}}
        </h2>
      </div>
    </div>
    <div class="pt-6">
      <dcp-plans-and-pricing-common-features
        [product]="product"
      ></dcp-plans-and-pricing-common-features>
      <div
        *ngFor="let bundleTemplate of filteredBundleTemplates; let i = index"
        [class.mt-sm-7]="i"
        data-cy="plans-and-pricing-bundle-option"
      >
        <div [class.d-none]="!i" class="d-sm-none ds-grid container-fluid">
          <div class="row">
            <div class="col">
              <div class="w-100 separator mt-6 mb-7"></div>
            </div>
          </div>
        </div>
        <dcp-plans-and-pricing-bundle-option
          [bundleTemplate]="bundleTemplate"
        ></dcp-plans-and-pricing-bundle-option>
      </div>
      <div class="ds-shadow mt-6"></div>
    </div>
  </div>
</ng-container>
